import React from 'react';
import { Translate } from 'react-localize-redux';
import { ColourChip } from '../../../components/general/mini_components-ts';

// ColourChip renders the label in white, so these backgrounds must be saturated
// enough for white text to read. The earlier pale tints (#F3F4F6 / #DCFCE7) left
// the status label nearly invisible on the white page.
//
// One entry per status the API stores on a visit: VisitStatus (DRAFT, SUBMITTED,
// LOCKED, VOIDED = retired by a data repair) plus the legacy OPEN that production
// rows still carry. Each has a label at pages.hospital.cases.status.<STATUS>.
const CASE_STATUS_COLORS: Record<string, string> = {
    'DRAFT': '#6B7280',
    'OPEN': '#6B7280',
    'SUBMITTED': '#16A34A',
    'LOCKED': '#2563EB',
    'VOIDED': '#B45309',
};

/** A status missing from the list above shows its raw code rather than a missing-translation message. */
const UNKNOWN_STATUS_COLOR = '#6B7280';

export const CaseStatusChip: React.FC<{status: string}> = ({status}) => {
    const known = Object.prototype.hasOwnProperty.call(CASE_STATUS_COLORS, status);
    const label = known ? <Translate id={`pages.hospital.cases.status.${status}`} /> : status;
    return <ColourChip rgbcolor={known ? CASE_STATUS_COLORS[status] : UNKNOWN_STATUS_COLOR} label={label} />;
};
